import React from 'react'
import { Helmet } from 'react-helmet'
import Navbar8 from '../components/navbar8'
import Hero3 from '../components/hero3'
import Gallery1 from '../components/gallery1'
import Features17 from '../components/features17'
import Features18 from '../components/features18'
import Features19 from '../components/features19'
import Features20 from '../components/features20'
import Features171 from '../components/features171'
import ContentList2 from '../components/content-list2'
import Footer4 from '../components/footer4'
import Features99 from '../components/features99'
import './initiatives.css'
 
const Initiatives = () => {
  const createTextFragment = (className, text) => (
    <span className={`initiatives-${className} thq-body-small thq-link`}>
      {text}
    </span>
  )
 
  const createHeadingFragment = (className, text) => (
    <span className={`initiatives-${className} thq-heading-2`}>
      {text}
    </span>
  )
 
  return (
    <div className="initiatives-container">
      <Helmet>
        <title>CAIC: Initiatives</title>
        <meta
          property="og:title"
          content="CAIC: Initiatives"
        />
      </Helmet>
      <Navbar8

      />
      <Hero3 />
      
      <Gallery1
        
        
      />
      <Features19
        feature1Title={createHeadingFragment('text34', 'Commonwealth and SAS AI Literacy Collaboration')}
        feature1Description={<span className="initiatives-text35 thq-body-large"style={{ textAlign: 'justify', display: 'block' }}>
          The Commonwealth Secretariat and SAS have launched an innovative initiative to empower learners and educators in Commonwealth countries by providing access to SAS Viya, a cloud-based platform on Microsoft Azure. This initiative equips users with cutting-edge tools for AI and data analytics, fostering the development of critical skills in visual analytics, model management, and open-source integration. Participants will also gain practical experience through educational resources and international AI competitions, with a strong focus on promoting responsible and ethical use of AI and data analytics.
        <a
          href="https://thecommonwealth.org/news/commonwealth-secretariat-and-sas-join-forces-secure-equitable-digital-future-young-people"
          target="_blank"
          rel="noopener noreferrer"
          className="initiatives-link thq-body-large"
        >
          <h5>Learn More...</h5>
        </a>
        </span>}
      />
      <Features20
        feature1Title={createHeadingFragment('text49', 'StrategusAI: AI Tool For Policy Makers')}
        feature1Description={<span className="initiatives-text50 thq-body-large" style={{ textAlign: 'justify'}}>
          The Commonwealth Secretariat, in partnership with Intel, has launched StrategusAI, an AI-powered policy toolkit designed to assist policymakers across the Commonwealth in crafting tailored government strategies that integrate global best practices with local needs. Developed under the leadership of the Government of Rwanda and as part of the Commonwealth AI Consortium’s Policy Development Working Group, StrategusAI aims to help member states navigate the challenges and capitalize on the opportunities of artificial intelligence. After months of development and testing, the tool will be piloted in Fiji and Brunei Darussalam before being rolled out to all 56 Commonwealth nations.
          <a
          href="https://thecommonwealth.org/news/commonwealth-secretariat-and-intel-launches-strategusai-ai-driven-policy-toolkit-commonwealth"
          target="_blank"
          rel="noopener noreferrer"
          className="initiatives-link thq-body-large"
        >
          <h5>Learn More...</h5>
        </a>
        </span>}
      />
      <Features17
        feature1Title={createHeadingFragment('text34', 'Commonwealth AI Incubator')}
      />
      <Features18
        feature1Title={createHeadingFragment('text49', 'AI entrepreneurship Make-A-Thon')}
        feature1Description={<span className="initiatives-text50 thq-body-large" style={{ textAlign: 'justify'}} >
          The Make-A-Thon is a unique initiative in collaboration with the Commonwealth and OpenWeaver aims to build the AI research, capacity data and infrastructure environment for the stakeholders in the Commonwealth including youths, women and anyone interested in a no code or low-code environment. The package provides for education and capacity to ensure that participants develop practical and industry-ready solutions for scaling up. In the long term, this will have a multiplier impact on Commonwealth economies by changes in education, economy, and employment. This is available for women MSMEs to learn practical digital solution building, develop applications and then scale their business. They will also be provided with free cloud credits for three years. Open Weaver will provide USD 4 million in cloud credits for three years.
          <a
          href="https://thecommonwealth.org/news/get-involved-digital-consumer-digital-creator-open-weaver"
          target="_blank"
          rel="noopener noreferrer"
          className="initiatives-link thq-body-large"
        >
          <h5>Learn More...</h5>
        </a>
        </span>}
      />
      <Features171
        feature1Title={createHeadingFragment('text51', 'Commonwealth AI Academy')}
        feature1Description={<span className="initiatives-text52 thq-body-large" style={{ textAlign: 'justify' }}>
          The Commonwealth, under Secretary-General Rt Hon Patricia Scotland KC, is driving digital growth with a strong focus on artificial intelligence (AI) across its 56 member states. With a commitment to inclusion, particularly among 1.5 billion young citizens, including underserved groups such as girls and the differently-abled, the newly launched Commonwealth AI Academy is a key initiative. In partnership with Intel, the Academy offers six online courses through the Commonwealth eLearning Platform, providing essential AI skills to equip individuals for a technology-driven future. This initiative aligns with the Commonwealth's broader efforts to harness digital innovation for social and economic development.
          <a
          href="https://cwlearn.commonwealth.int/course/index.php?categoryid=13"
          target="_blank"
          rel="noopener noreferrer"
          className="initiatives-link thq-body-large"
        >
          <h5>Learn More...</h5>
        </a>
        </span>}
      />
      <Features99
        feature1Title={createHeadingFragment('text51', 'Simplilearn E-Learning Platorm')}
      />
      <ContentList2
    />
      <Footer4></Footer4>
        
    </div>
  )
}
 
export default Initiatives